import { Product } from '../entities/Product';
import { InventoryStatus } from '../../constants/InventoryStatuses';
import { Sku } from '../entities/Sku';

export type ISortingOrder = {
    [key: string]: number;
};

export class InventoryStatusSortingStrategy {
    private sortingOrder: ISortingOrder;
    private enableBackorder: boolean;

    constructor(inventoryStatuses: string[], enableBackorder = false) {
        this.sortingOrder = inventoryStatuses.reduce((computedStatuses, inventoryStatus, index) => {
            computedStatuses[inventoryStatus.toLowerCase()] = index;

            return { ...computedStatuses };
        }, {} as ISortingOrder);
        this.enableBackorder = enableBackorder;
    }

    public sortProductsByInventory = (productA: Product, productB: Product) => {
        const valueA = this.getInventoryStatusValue(productA);
        const valueB = this.getInventoryStatusValue(productB);

        return this.sortByInventory(valueA, valueB);
    };

    public sortSkusByInventory = (skuA: Sku, skuB: Sku) => {
        const inventoryStatusA = this.getSkuSortInventoryStatusValue(skuA);
        const inventoryStatusB = this.getSkuSortInventoryStatusValue(skuB);

        return this.sortByInventory(
            this.getInventoryStatusIndex(inventoryStatusA),
            this.getInventoryStatusIndex(inventoryStatusB)
        );
    };

    private sortByInventory = (valueA: number, valueB: number) => {
        if (valueA === valueB) {
            return 0;
        }

        return valueA > valueB ? 1 : -1;
    };

    private getSkuSortInventoryStatusValue(sku: Sku): string {
        if (sku.inventoryStatus === InventoryStatus.TempOutOfStock && this.enableBackorder) {
            return InventoryStatus.Active;
        }

        return sku.inventoryStatus;
    }

    private getInventoryStatusValue(product: Product): number {
        let inventoryStatus = InventoryStatus.Active;

        if (product.isOutOfStock && !this.enableBackorder) {
            inventoryStatus = InventoryStatus.TempOutOfStock;
        }

        if (product.isSoldOut) {
            inventoryStatus = InventoryStatus.SoldOut;
        }

        return this.getInventoryStatusIndex(inventoryStatus);
    }

    private getInventoryStatusIndex(inventoryStatusValue: string) {
        const computedStatusKey = inventoryStatusValue.toLowerCase();

        return this.sortingOrder.hasOwnProperty(computedStatusKey)
            ? this.sortingOrder[computedStatusKey]
            : -1;
    }
}
